import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="w-full bg-secondary-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-line text-lg text-white"></i>
              </span>
              <span className="text-xl font-heading font-bold text-white">
                吃瓜在线
              </span>
            </div>
            <p className="text-sm text-white/60 leading-relaxed">
              {footerData.desc}
            </p>
          </div>

          {/* Link Columns */}
          {footerData.sections.map((section, idx) => (
            <div key={idx}>
              <h4 className="text-sm font-semibold text-white mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => handleClick(e, link.href)}
                      className="text-sm text-white/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Partners */}
        <div className="border-t border-white/10 pt-8 mb-8">
          <h4 className="text-sm font-semibold text-white/50 mb-4">合作伙伴</h4>
          <div className="flex flex-wrap gap-4">
            <span className="text-sm text-white/30">更多合作伙伴即将入驻</span>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            &copy; 2026 吃瓜在线. All rights reserved.
          </p>
          <p className="text-xs text-white/30">
            本站内容仅供娱乐参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}